export type Testimonial = {
  id: string;
  brand: string;
  logoSrc: string;
  quote: string;
  attribution: string;
  metric: string;
  metricLabel: string;
  source: string;
  caseHref: string;
  panelColor: string;
};

export type IntegrationItem = {
  label: string;
  icon: "messages" | "site" | "crm" | "order" | "stock" | "booking";
};

export const testimonialsIntro = {
  kicker: "客户证言",
  title: "真实业务现场，验证每一步推进",
  body: "从及时承接到激活沉默线索，3Chat 的价值最终由客户行为和业务结果验证",
} as const;

export const testimonials: Testimonial[] = [
  {
    id: "xiaojiyan",
    brand: "小极研造",
    logoSrc: "/images/customer_logo/Passion Propels.svg",
    quote:
      "3Chat 不仅接住了夜间和周末的咨询，还能循序渐进地激活沉默线索。接入当月，门店自然到店量提升了 20%，团队也有更多精力跟进高价值客户。",
    attribution: "舍尔弗衣柜（小极研造）| 定制家居",
    metric: "20%",
    metricLabel: "当月门店自然到店量提升",
    source: "来源：舍尔弗公开客户案例",
    caseHref:
      "/blog/3chat-ai-customer-service-custom-furniture-client-case-study",
    panelColor: "#00b7ff",
  },
  {
    id: "shopline",
    brand: "SHOPLINE",
    logoSrc: "/images/customer_logo/shopline.svg",
    quote:
      "3Chat 把产品咨询、客户画像与精准转人工真正连接起来，让团队能把更多精力投入高价值服务与复杂商机。",
    attribution: "SHOPLINE | 跨境电商 SaaS",
    metric: "3x",
    metricLabel: "整体核心人效提升",
    source: "来源：SHOPLINE 公开客户案例",
    caseHref: "/blog/shopline-x-3chat-customer-story",
    panelColor: "#9c7ceb",
  },
];

export const testimonialIntegrationsLead =
  "连接客户对话与真正完成交易的业务系统";

export const testimonialIntegrations: IntegrationItem[] = [
  { label: "企微 / 微信", icon: "messages" },
  { label: "官网", icon: "site" },
  { label: "CRM", icon: "crm" },
  { label: "订单", icon: "order" },
  { label: "库存", icon: "stock" },
  { label: "预约", icon: "booking" },
];
